import { endOfDay, isAfter } from 'date-fns';

/**
 * Offer end dates are calendar days (date-only). Valid through 23:59:59.999
 * local time on that day — matching how endDate is shown in the UI.
 */
export const isOfferPastEndDate = (
  endDate: Date | string,
  now: Date = new Date()
): boolean => isAfter(now, endOfDay(new Date(endDate)));

export const getOfferEndDateInclusiveLimit = (
  endDate: Date | string
): Date => endOfDay(new Date(endDate));
